import { useContext } from 'react';

import { fontStyles } from '@/styles/typography';

import { Route } from '@/utils/0x.types';

import { transformRouteToSankeyLegend } from '../helpers';
import { SankeyContext } from '../SankeyProvider';

interface SankeyLegendProps {
  route: Route;
}

export const SankeyLegend = ({ route }: SankeyLegendProps) => {
  const legendData = transformRouteToSankeyLegend({ route });
  const { onLegendHover } = useContext(SankeyContext);

  return (
    <div className="flex flex-wrap gap-3">
      {legendData.map(({ source, gradient, label }) => (
        <div
          key={source}
          className="flex items-center gap-2"
          onMouseMove={() => onLegendHover(source)}
          onMouseLeave={() => onLegendHover(undefined)}
        >
          <div
            className="size-3 rounded-2xs"
            style={{ background: `linear-gradient(${gradient?.start}, ${gradient?.end})` }}
          />
          <span className={fontStyles({ variant: 'CAPTION' })}>{label}</span>
        </div>
      ))}
    </div>
  );
};
